module.exports = __webpack_public_path__ + "static/media/video-turnoff-off.de0e47e9.svg";